// 应用启动时（客户端）拉取服务端计价开关，供所有价格预览入口（定价页、
// 企业分配/批量激活弹窗等）读取。幂等且非阻塞：失败保持默认自然月预览。
// 放在 store 里统一读取，避免逐一穿参导致预览与后端实扣口径不一致。
export default defineNuxtPlugin(() => {
  const route = useRoute()
  const rawTarget = Array.isArray(route.query.asUser)
    ? route.query.asUser[0]
    : route.query.asUser
  const targetUserId = Number(rawTarget)
  usePricing().loadPricingConfig(
    Number.isInteger(targetUserId) && targetUserId > 0
      ? targetUserId
      : undefined,
  )
})
